import type { ReactNode } from "react";

export function ErrorScreen({
  code,
  title,
  description,
  icon = "fa-paw",
  note,
  children,
}: {
  code: string;
  title: string;
  description: string;
  icon?: string;
  note?: string;
  children?: ReactNode;
}) {
  return (
    <div className="paw-grid-paper relative flex min-h-[100svh] items-center justify-center overflow-hidden px-5 py-16">
      <div className="pointer-events-none absolute inset-x-0 top-0">
        <div className="paw-hazard" />
      </div>

      <section className="relative w-full max-w-xl border border-(--paw-line-strong) bg-(--paw-panel) p-6 shadow-[6px_6px_0_var(--paw-signal-deep)] sm:p-9">
        <div className="font-paw-mono text-[11px] tracking-[0.2em] text-(--paw-signal)">
          {code}
        </div>

        <div className="my-8 flex flex-col items-start gap-5 border-y border-(--paw-line) py-6 sm:flex-row sm:items-center">
          <div
            className="relative flex h-24 w-16 shrink-0 -rotate-3 items-end justify-center border-2 border-(--paw-signal) bg-(--paw-ink) pb-3 shadow-[4px_4px_0_var(--paw-signal-deep)]"
            aria-hidden="true"
          >
            <span className="absolute top-2.5 h-3 w-3 rounded-full border-2 border-(--paw-signal)" />
            <i className={`fa-solid ${icon} text-2xl text-(--paw-signal)`} />
          </div>
          <div>
            <h1 className="paw-display text-[42px] leading-[1.02] text-(--paw-paper) uppercase sm:text-[54px]">
              {title}
            </h1>
            <p className="mt-3 max-w-md text-sm leading-6 text-(--paw-steel-dim)">
              {description}
            </p>
          </div>
        </div>

        {children ? (
          <div className="flex flex-col gap-3 sm:flex-row">{children}</div>
        ) : null}

        {note ? (
          <p className="mt-7 font-paw-mono text-[10px] tracking-[0.12em] text-(--paw-steel-faintest)">
            {note}
          </p>
        ) : null}
      </section>
    </div>
  );
}
